import { render, staticRenderFns } from "./web.vue?vue&type=template&id=206ae0aa&scoped=true&"
var script = {}
import style0 from "./web.vue?vue&type=style&index=0&id=206ae0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ae0aa",
  null
  
)

export default component.exports